/* Rich-text/page-body links do not pass through Liquid button snippets.
   Normalize only same-origin storefront content links; never checkout,
   account authentication, downloads, external sites, mail or phone links. */
(() => {
  const config = document.querySelector('script[data-localized-navigation]');
  if (!config) return;
  const root = (config.dataset.rootUrl || '/').replace(/\/$/, '');
  const localePrefixes = new Set(['en', 'fr']);
  try { JSON.parse(config.dataset.locales || '[]').forEach(code => localePrefixes.add(code)); } catch (_) {}
  const resolve = (value) => {
    if (!value || /^(#|\?|mailto:|tel:|javascript:|data:)/i.test(value.trim())) return value;
    let url;
    try { url = new URL(value, window.location.href); } catch (_) { return value; }
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return value;
    let path = url.pathname;
    const parts = path.split('/');
    if (localePrefixes.has(parts[1])) path = '/' + parts.slice(2).join('/');
    if (path !== '/' && !/^\/(pages|products|collections|blogs|policies|search)(\/|$)/.test(path)) return value;
    return (root + (path === '/' ? '/' : path)) + url.search + url.hash;
  };
  const fix = anchor => {
    if (anchor.hasAttribute('download') || anchor.closest('[data-allow-language-change],.header__language-form')) return;
    const old = anchor.getAttribute('href'), next = resolve(old);
    if (old !== next) anchor.setAttribute('href', next);
  };
  const scan = node => {
    if (!(node instanceof Element)) return;
    if (node.matches('a[href]')) fix(node);
    node.querySelectorAll('a[href]').forEach(fix);
  };
  scan(document.body);
  document.addEventListener('click', event => {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (anchor) fix(anchor);
  }, true);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
  }).observe(document.body, { childList: true, subtree: true });
})();
